import React, { forwardRef, useEffect, useImperativeHandle, useState } from 'react';
import axios from 'axios';
import { Upload, message, UploadFile } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import './photo.less';
import formAction from '../../utils/formAction';
import { makeThumb, proxyFileUpload } from '../ocr-autofill/utils';
import ImageViewer from '../image-viewer';
import { readProjectItem } from '../../../../utils/storage';

function PhotoOssCom(props: any, ref: any) {
    const [previewVisible, setPreviewVisible] = useState<boolean>(false);
    const [previewTitle, setPreviewTitle] = useState<string>('');
    const [fileList, setFileList] = useState<any>([]);
    const [value, setValue] = useState<any>([]);
    const [data, setData] = useState<any>();
    const [formId, setFormId] = useState<any>();
    const [dataActions, setDataActions] = useState<any>([]);
    const [formIsRead, setFormIsRead] = useState<boolean>(true);
    const [savedValues, setSavedValues] = useState<any>([]);
    const [previewImage, setPreviewImage] = useState<any>();
    const [isUpdate, setIsUpdate] = useState<boolean>(false);
    const [updatedValue, setUpdatedValue] = useState<any>([]);

    const [visible, setVisible] = useState(false);

    useEffect(() => {
        if (props.data) {
            //设置dataActions
            setDataActions(props.dataActions);
            //表单是否只读
            setFormIsRead(props.formIsRead);
            //获取当前表单的id
            setFormId(props.formId);
            //该条表单元素的数据
            setData(props.data);
            //已经保存的表单数据
            setSavedValues(props.savedValues);
            //如果是修改时
            if (props.isUpdate) {
                setIsUpdate(props.isUpdate)
            }
            else {
                setIsUpdate(false)
            }
            //设置当前表单已存的value
            let currentItem = props.savedValues.find((i: any) => {
                return i.dataCode == props.data.dataCode
            });
            if (currentItem) {
                let fieldList = [];
                if (currentItem.value) {
                    for (let item of currentItem.value) {
                        fieldList.push(makeThumb(item))
                    }
                }

                const old = value.map(({url}: any)=> url).join(',')
                const now = fieldList.map(({url})=> url).join(',')

                if(old != now) {
                    setValue(fieldList);
                    setFileList(fieldList);
                    setUpdatedValue(fieldList);
                }
            }
            else {
                setValue([])
                setFileList([]);
                setUpdatedValue([]);
            }
        }
    }, [props.data, props.savedValues])


    //图片预览
    const handlePreview = ({ url }: UploadFile) => {
        setPreviewImage(url);
        setPreviewVisible(true);
    }

    const tuoMin = (url: String) => {
        const postData = {
            "areaList": [],
            "fileUrl": url,
            "formId": formId,
            "platform": 0, // 1为h5, 0为pc
            // @ts-ignore
            "subjectCode": readProjectItem('subjectCode') as string
        };
        axios.post("/file/image/desensitizate", postData);
    }

    const handleChange = async ({file}: any) => {

        if(!file) {
            return
        }

        const [_, ext] = file.type.split('/')
        if(!['.jpg', '.jpeg', '.png'].includes(`.${ext}`)) {
            message.error('上传格式不允许')
            return
        }

        // 通过后端代理上传至OSS
        const uploadResult = await proxyFileUpload(file);

        if (!uploadResult) {
            message.error('上传失败，请重试！')
            return;
        }

        const url = uploadResult.url;

        const thumbs = [
            ...value,
            makeThumb(url)
        ]
        setValue(thumbs);
        setFileList(thumbs);

        if (isUpdate === true) {
            setUpdatedValue(thumbs);
        }
        else {
            saveData(thumbs);
        }
        // 因为要进行记录，需要更新脱敏接口
        // tuoMin(url);
    }

    //暂存数据
    const saveData = (value: any) => {
        let filterArr = [];
        for (let item of value) {
            if (item.url) {
                filterArr.push(item.url);
            }
        }
        let values = [
            {
                dataCode: data.dataCode,
                deCode: data.deCode,
                value: filterArr
            }
        ];
        let params = {
            formId: formId,
            submit: false,
            values: values
        }
        formAction.saveData(params);
        // props.startTimerFun();
        props.updateFun()
        // saveFormData(params).then((res) => {
        //     props.updateFun()
        // })
    }

    const handleCancel = () => {
        setPreviewVisible(false);
    }

    const uploadButton = (
        <div>
            <PlusOutlined />
            <div style={{ marginTop: 8 }}>点击上传图片</div>
        </div>
    );

    const beforeUploadControl = (file: File) => {
        return file;
      };

    useImperativeHandle(ref, () => ({
        // changeVal 就是暴露给父组件的方法
        getModifyValue: () => {
            let filterArr = [];
            for (let item of updatedValue) {
                if (item.url) {
                    filterArr.push(item.url);
                }
            }
            let params = {
                dataCode: data.dataCode,
                deCode: data.deCode,
                formId: formId,
                value: filterArr,
            }
            return params;
        },
    }));


    const removeChange = (file: any) => {
        let _fileList = fileList.filter((v: any) => v.uid !== file.uid)
        setValue(_fileList)
        setFileList(_fileList)
        if (isUpdate === true) {
            setUpdatedValue(_fileList);
        }
        else {
            saveData(_fileList);
        }
    }

    return (
        <div className="photoCom">
            {
                <div>
                    <Upload
                        // action={`${BASE_URL}data/data/image`} // 之前的上传接口
                        // action={`${BASE_URL}file/image/upload`} // 脱敏图片上传接口
                        method="POST"
                        accept=".jpg, .jpeg, .png"
                        // @ts-ignore
                        customRequest={handleChange}
                        listType="picture-card"
                        fileList={fileList}
                        beforeUpload={beforeUploadControl}
                        onPreview={handlePreview}
                        onRemove={removeChange}
                        disabled={!formIsRead}
                    >
                        {value.length >= 30 ? null : uploadButton}
                    </Upload>
                    <ImageViewer visible={previewVisible} urls={fileList.map(({url}: {url: string})=> url)} url={previewImage} onClose={()=> setPreviewVisible(false)}/>
                </div>
            }
        </div>
    )
}

export default forwardRef(PhotoOssCom);
